export const DEFAULT_PAGINATION_SIZE = 50;

export interface PaginationRequest {
  page: number;
  size: number;
  sort?: string[];
}

export interface PaginationResponse {
  size: number;
  number: number;
  totalElements?: number;
  page?: number;
  totalPages?: number;
  rightPage?: boolean;
  leftPage?: boolean;
}
